import {
  REPORT_DOWNLOAD,
  REPORT_DOWNLOAD_FAIL,
  REPORT_DOWNLOAD_RESET,
  REPORT_DOWNLOAD_SUCCESS,
  REPORT_EXPORT,
  REPORT_EXPORT_FAIL,
  REPORT_EXPORT_RESET,
  REPORT_EXPORT_SUCCESS,
  REPORT_LIST,
  REPORT_LIST_COLUMN,
  REPORT_LIST_FAIL,
  REPORT_LIST_RESET,
  REPORT_LIST_SUCCESS,
} from "./actionTypes";

// List Report
export const listReport = (params = {}) => ({
  type: REPORT_LIST,
  payload: { params },
});

export const listReportSuccess = data => ({
  type: REPORT_LIST_SUCCESS,
  payload: data,
});

export const listReportFail = error => ({
  type: REPORT_LIST_FAIL,
  payload: error,
});

export const resetListReport = () => ({
  type: REPORT_LIST_RESET,
  payload: {},
});

export const setListReportColumn = (field, value) => ({
  type: REPORT_LIST_COLUMN,
  payload: { field, value },
});

// Export Report
export const exportReport = (data = {}) => ({
  type: REPORT_EXPORT,
  payload: { data },
});

export const exportReportSuccess = data => ({
  type: REPORT_EXPORT_SUCCESS,
  payload: data,
});

export const exportReportFail = error => ({
  type: REPORT_EXPORT_FAIL,
  payload: error,
});

export const resetExportReport = () => ({
  type: REPORT_EXPORT_RESET,
  payload: {},
});

// Download Report
export const downloadReport = (fileId = 0, fileName) => ({
  type: REPORT_DOWNLOAD,
  payload: { fileId, fileName },
});

export const downloadReportSuccess = data => ({
  type: REPORT_DOWNLOAD_SUCCESS,
  payload: data,
});

export const downloadReportFail = error => ({
  type: REPORT_DOWNLOAD_FAIL,
  payload: error,
});

export const resetDownloadReport = () => ({
  type: REPORT_DOWNLOAD_RESET,
  payload: {},
});
